import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doom-fire-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "doom-fire" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import {
  onMounted, onUnmounted, ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Fire',
  setup(__props) {

const FPS_LIMIT = 15;
const interval = 1000 / FPS_LIMIT;
let animationStartTime = Date.now();
let now;
let delta;

const animationRequest = ref(0);
const firePixelsArray: number[] = [];
let fireWidth = 60;
let fireHeight = 28;
const decayScale = 8;
const fireColorsPalette = [
  '#07070700',
  '#1f07071a',
  '#2f0f0742',
  '#470f077a',
  '#5717079c',
  '#671f07bf',
  '#771f07d6',
  '#8f2707',
  '#9f2f07',
  '#af3f07',
  '#bf4707',
  '#c74707',
  '#DF4F07',
  '#DF5707',
  '#DF5707',
  '#D75F07',
  '#D7670F',
  '#cf6f0f',
  '#cf770f',
  '#cf7f0f',
  '#CF8717',
  '#C78717',
  '#C78F17',
  '#C7971F',
  '#BF9F1F',
  '#BF9F1F',
  '#BFA727',
  '#BFA727',
  '#BFAF2F',
  '#B7AF2F',
  '#B7B72F',
  '#B7B737',
  '#cfcf6f',
  '#dfdf9f',
  '#efefc7aa',
  '#f6f6f6aa',
  '#ffffffaa',
];

function start() {
  createFireDataStructure();
  createFireSourceData();
  // @dev: on the next available frame let's draw our first frame
  requestAnimationFrame(calculateFirePropagationDraw);
}

function createFireDataStructure() {
  const numberOfPixels = fireWidth * fireHeight;

  for (let i = 0; i < numberOfPixels; i++) {
    firePixelsArray[i] = 0;
  }
}

function calculateFirePropagationDraw() {
  // recursive: on the next available frame we draw again
  animationRequest.value = requestAnimationFrame(calculateFirePropagationDraw);

  now = Date.now();
  delta = now - animationStartTime;

  if (delta > interval) {
    animationStartTime = now - (delta % interval);
    for (let column = 0; column < fireWidth; column++) {
      for (let row = 0; row < fireHeight; row++) {
        const pixelIndex = column + fireWidth * row;

        updateFireIntensityPerPixel(pixelIndex);
      }
    }

    renderFire();
  }
}

function updateFireIntensityPerPixel(currentPixelIndex: number) {
  const belowPixelIndex = currentPixelIndex + fireWidth;

  // below pixel index overflows canvas
  if (belowPixelIndex >= fireWidth * fireHeight) {
    return;
  }

  const decay = Math.floor(Math.random() * decayScale);
  const belowPixelFireIntensity = firePixelsArray[belowPixelIndex];
  const newFireIntensity =
    belowPixelFireIntensity - decay >= 0 ? belowPixelFireIntensity - decay : 0;

  firePixelsArray[currentPixelIndex - decay] = newFireIntensity;
}

function renderFire() {
  let html = '<table cellpadding=0 cellspacing=0>';

  for (let row = 0; row < fireHeight; row++) {
    html += '<tr>';

    for (let column = 0; column < fireWidth; column++) {
      const pixelIndex = column + fireWidth * row;
      const fireIntensity = firePixelsArray[pixelIndex];
      const color = fireColorsPalette[fireIntensity];

      html += `<td class="pixel" style="background-color: ${color}">`;
      html += '</td>';
    }

    html += '</tr>';
  }

  html += '</table>';

  var c = document.querySelector('#doom-fire');
  if (c) {
    c.innerHTML = html;
  }
}

function createFireSourceData() {
  for (let column = 0; column <= fireWidth; column++) {
    const overflowPixelIndex = fireWidth * fireHeight;
    const pixelIndex = overflowPixelIndex - fireWidth + column;

    firePixelsArray[pixelIndex] = 36;
  }
}

onMounted(() => {
  start();
});

onUnmounted(() => {
  cancelAnimationFrame(animationRequest.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})